"use client";
import { useMutation } from "@tanstack/react-query";
import { HeartIcon } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { ApiResponse } from "@/lib/fetch";
import { favoriteNameAction } from "./action";

interface Props {
  id: string;
  initialFavorited: boolean;
}

const NameFavoriteButtonClient = ({ id, initialFavorited }: Props) => {
  const [favorited, setFavorited] = useState(initialFavorited);

  type Snapshot = { favorited: boolean };

  const { mutate, isPending } = useMutation<
    ApiResponse<unknown>,
    Error,
    boolean,
    Snapshot
  >({
    mutationFn: (currentFavorited: boolean) =>
      favoriteNameAction(id, currentFavorited),
    onError: (_err, _vars, snapshot) => {
      if (snapshot) {
        setFavorited(snapshot.favorited);
      }
    },
    onMutate: (currentFavorited) => {
      const snapshot = { favorited };
      setFavorited(!currentFavorited);
      return snapshot;
    },
    onSuccess: (res, _vars, snapshot) => {
      if (!res.isSuccess && snapshot) {
        setFavorited(snapshot.favorited);
      }
    },
  });

  return (
    <Button
      className="group"
      disabled={isPending}
      onClick={() => mutate(favorited)}
      size="icon-sm"
      variant="ghost"
    >
      <HeartIcon
        className={
          favorited
            ? "size-6 stroke-[1.5] stroke-brand-blue-500 fill-brand-blue-100"
            : "size-6 stroke-[1.5] stroke-neutral-400 fill-none group-hover:stroke-brand-blue-500 group-hover:fill-brand-blue-100"
        }
      />
    </Button>
  );
};

export { NameFavoriteButtonClient };
